import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import {
  BakeasyButtonCancel,
  BakeasyButtonShippingMemoInvoice,
  BakeasyButtonShippingMemoOnly,
  BakeasyButtonUpdateShipping,
} from '../../components/buttons/BakeasyButton';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { shippedOrderTableHeaders } from '../../constants/TableHeaders';
import { Close } from '@mui/icons-material';
import { t } from 'i18next';
import {
  clearOrdersState,
  shippedOrder,
} from '../../redux_store/slices/ordersSlice';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import i18n from '../../languages/languages';
import {
  BakeasyAutoCompleteShippingMethod,
  BakeasyAutoCompleteState,
} from '../../components/dropdowns/BakeasyAutoComplete';
import { shippingMethodsState } from '../../redux_store/slices/shippingMethodsSlice';
import { createInvoice } from '../../redux_store/slices/invoiceSlice';
import {
  isParsableToFloat,
  removePercentageFromTax,
} from '../../utils/ValidationUtils';

export const ShippedOrder = (props: any) => {
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);
  const navigate = useNavigate();

  const [ordersList, setOrdersList] = useState<any[]>(
    state?.selectedOrders?.length ? state.selectedOrders : []
  );
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>('');
  const [shipToState, setShipToState] = useState<any>('');
  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');

  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');
  const [showButton, setShowButton] = React.useState(false);

  let _shippingMethodsState = useAppSelector(shippingMethodsState);

  useEffect(() => {
    if (props?.params?.data) {
      setData(props?.params?.data);
    }
  }, [props?.isEdit?.params?.data]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  function setData(data: any) {
    if (data?.products?.length > 0) {
      const orders = data?.products?.map((item: any) => {
        item.unitPrice = item?.price;
        item.quantity = item?.quantity;
        item.confirmedQuantity = item?.confirmedQuantity && item?.quantity;
        item.shippingQuantity = item?.shippingQuantity && item?.quantity;
        item.price = item?.price;
        item.totalPrice = item?.totalPrice;
        item.backOrderChecked = false;
        item.processOrderChecked = false;
        item.cancelOrderChecked = false;
        return item;
      });
      setOrdersList(orders);

      setSelectedShipTo(data?.selectedValue?.shipTo);
      setShipToName(data?.selectedValue?.shipToInfo?.name);
      setShipToCompanyName(data?.selectedValue?.shipToInfo?.companyName);
      setShipToAddress(data?.selectedValue?.shipToInfo?.companyAddress);
      setShipToCity(data?.selectedValue?.shipToInfo?.city);
      setShipToState(data?.selectedValue?.shipToInfo?.state);
      setShipToPostCode(data?.selectedValue?.shipToInfo?.zipCode);
      setShipToCountry(data?.selectedValue?.shipToInfo?.country);
      setSelectedShippingCharge(
        data?.selectedValue?.shippingCharges
          ? i18n.language === 'fr'
            ? 'Oui'
            : 'Yes'
          : i18n.language === 'fr'
            ? 'Non'
            : 'No'
      );
      setSelectedShippingCalculation(data?.selectedValue?.shippingRateType);
      setShippingCharges(data?.selectedValue?.shippingRate);
      setSelectedPreferredShippingMethod(
        data?.selectedValue?.preferredShippingMethod
          ? { methodName: data?.selectedValue?.preferredShippingMethod }
          : null
      );
    }
  }

  useEffect(() => {
    if (selectedRows.length > 0) {
      const updatedOrdersList = ordersList.map((order) => {
        const selectedRow = selectedRows.find(
          (row: any) => row._id === order._id
        );
        if (selectedRow) {
          return { ...order, ...selectedRow };
        }
        return order;
      });

      setOrdersList(updatedOrdersList);
    }
  }, [selectedRows]);

  function handleCheckQuantityChange(row: any) {
    let filteredRowIndex1 = ordersList.findIndex(
      (tableRow: any) => tableRow.productId === row?.productId
    );
    if (filteredRowIndex1 >= 0) {
      let a = ordersList;
      a[filteredRowIndex1] = row;
      setOrdersList([...a]);
    }
  }

  const handleQuantityChange = (row: any, value: any) => {
    handleCheckQuantityChange(row);
  };

  const handleUpdateShipping = () => {
    setShowButton(true);
  };
  //commented for shipping charge change
  // async function calculateTotalPrice(products: any) {
  //   let subTotal1: number = products?.reduce((total: number, order: any) => {
  //     let tempTotalPrice =
  //       total +
  //       parseFloat(
  //         (
  //           parseFloat(order?.shippingQuantity ?? order?.confirmedQuantity) *
  //           parseFloat(order?.price)
  //         ).toFixed(2)
  //       );

  //     return tempTotalPrice;
  //   }, 0);

  //   subTotal1 = parseFloat(subTotal1.toFixed(2));
  //   let calculatedsubTotal = subTotal1;

  //   const getTaxRate = (taxRate: string | undefined) => {
  //     if (!taxRate || taxRate === 'Not Applicable') return 0;
  //     const cleanedTaxRate = removePercentageFromTax(taxRate);
  //     return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
  //   };

  //   const taxRate1 = getTaxRate(
  //     props?.params?.data?.selectedValue?.taxes?.rate1
  //   );
  //   const taxRate2 = getTaxRate(
  //     props?.params?.data?.selectedValue?.taxes?.rate2
  //   );
  //   if (isNaN(subTotal1)) subTotal1 = 0;
  //   const safeTaxRate1 = isNaN(taxRate1) ? 0 : taxRate1;
  //   const safeTaxRate2 = isNaN(taxRate2) ? 0 : taxRate2;

  //   const calculatedtax1: number = parseFloat(
  //     ((safeTaxRate1 / 100) * subTotal1).toFixed(2)
  //   );
  //   const calculatedtax2: number = parseFloat(
  //     ((safeTaxRate2 / 100) * subTotal1).toFixed(2)
  //   );
  //   let calculatedshippingCharge: any = 0;
  //   let calculatedtotal: number = subTotal1 + calculatedtax1 + calculatedtax2;
  //   if (props?.params?.selectedShippingCalculation === 'Percentage') {
  //     calculatedshippingCharge = parseFloat(
  //       (
  //         (parseFloat(props?.params?.shippingCharges) / 100) *
  //         subTotal1
  //       ).toFixed(2)
  //     );
  //     calculatedtotal = calculatedtotal + calculatedshippingCharge;
  //   } else if (props?.selectedShippingCalculation === 'Amount') {
  //     calculatedshippingCharge = t('TO_BE_CONFIRMED');
  //   }
  //   return {
  //     calculatedsubTotal,
  //     calculatedtax1,
  //     calculatedtax2,
  //     calculatedshippingCharge,
  //     calculatedtotal,
  //   };
  // }

  async function calculateTotalPrice(
    products: any,
    shippingCalc?: string,
    shippingRate?: any
  ) {
    let subTotal1: number = products?.reduce((total: number, order: any) => {
      const quantity = parseFloat(
        order?.shippingQuantity ?? order?.confirmedQuantity ?? 0
      );
      const price = parseFloat(order?.price ?? 0);
      return total + quantity * price;
    }, 0);

    subTotal1 = parseFloat(subTotal1.toFixed(2));

    const calculatedsubTotal = subTotal1;

    const getTaxRate = (taxRate: string | undefined) => {
      if (!taxRate || taxRate === 'Not Applicable') return 0;
      const cleanedTaxRate = removePercentageFromTax(taxRate);
      return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
    };

    const taxRate1 = getTaxRate(
      props?.params?.data?.selectedValue?.taxes?.rate1
    );

    const taxRate2 = getTaxRate(
      props?.params?.data?.selectedValue?.taxes?.rate2
    );

    const calculatedtax1 = parseFloat(
      ((taxRate1 / 100) * subTotal1).toFixed(2)
    );

    const calculatedtax2 = parseFloat(
      ((taxRate2 / 100) * subTotal1).toFixed(2)
    );

    let calculatedshippingCharge = 0;

    const shippingCalculation =
      shippingCalc ?? props?.params?.selectedShippingCalculation;
    const shippingChargesVal = parseFloat(
      shippingRate ?? props?.params?.shippingCharges ?? 0
    );

    if (shippingCalculation === 'Percentage') {
      calculatedshippingCharge = parseFloat(
        ((shippingChargesVal / 100) * subTotal1).toFixed(2)
      );
    } else if (shippingCalculation === 'Amount') {
      calculatedshippingCharge = parseFloat(shippingChargesVal.toFixed(2));
    }

    const calculatedtotal = parseFloat(
      (
        subTotal1 +
        calculatedtax1 +
        calculatedtax2 +
        calculatedshippingCharge
      ).toFixed(2)
    );

    return {
      calculatedsubTotal,
      calculatedtax1,
      calculatedtax2,
      calculatedshippingCharge,
      calculatedtotal,
    };
  }
  // async function calculateTotalPrice(products: any) {
  //   let subTotal1: number = products?.reduce((total: number, order: any) => {
  //     const quantity = parseFloat(
  //       order?.shippingQuantity ?? order?.confirmedQuantity ?? 0
  //     );

  //     const price = parseFloat(order?.price ?? 0);

  //     return total + quantity * price;
  //   }, 0);

  //   subTotal1 = parseFloat(subTotal1.toFixed(2));

  //   const calculatedsubTotal = subTotal1;

  //   const getTaxRate = (taxRate: string | undefined) => {
  //     if (!taxRate || taxRate === 'Not Applicable') return 0;

  //     const cleanedTaxRate = removePercentageFromTax(taxRate);

  //     return isParsableToFloat(cleanedTaxRate) ? parseFloat(cleanedTaxRate) : 0;
  //   };

  //   const taxRate1 = getTaxRate(
  //     props?.params?.data?.selectedValue?.taxes?.rate1
  //   );

  //   const taxRate2 = getTaxRate(
  //     props?.params?.data?.selectedValue?.taxes?.rate2
  //   );

  //   const calculatedtax1 = parseFloat(
  //     ((taxRate1 / 100) * subTotal1).toFixed(2)
  //   );

  //   const calculatedtax2 = parseFloat(
  //     ((taxRate2 / 100) * subTotal1).toFixed(2)
  //   );

  //   let calculatedshippingCharge = 0;

  //   const shippingCalculation = props?.params?.selectedShippingCalculation;

  //   const shippingCharges = parseFloat(props?.params?.shippingCharges || 0);

  //   if (shippingCalculation === 'Percentage') {
  //     // Example: 2% of 14100 = 282
  //     calculatedshippingCharge = parseFloat(
  //       ((shippingCharges / 100) * subTotal1).toFixed(2)
  //     );
  //   } else if (shippingCalculation === 'Amount') {
  //     // Example: entered amount = 20
  //     calculatedshippingCharge = parseFloat(shippingCharges.toFixed(2));
  //   }

  //   const calculatedtotal = parseFloat(
  //     (
  //       subTotal1 +
  //       calculatedtax1 +
  //       calculatedtax2 +
  //       calculatedshippingCharge
  //     ).toFixed(2)
  //   );

  //   return {
  //     calculatedsubTotal,
  //     calculatedtax1,
  //     calculatedtax2,
  //     calculatedshippingCharge,
  //     calculatedtotal,
  //   };
  // }
  async function createPayload(isInvoice?: boolean) {
    // if (!checkValidity()) {
    //   return false;
    // }
    let payload: any = {
      orderId: props?.params?._id,
      shipTo: selectedShipTo,
      shipToInfo: {
        name: shipToName,
        companyName: shipToCompanyName,
        companyAddress: shipToAddress,
        city: shipToCity,
        zipCode: shipToPostCode,
        state: shipToState,
        country: shipToCountry,
      },
      shippingCharges:
        selectedShippingCharge === 'Yes' || selectedShippingCharge === 'Oui'
          ? true
          : false,
      shippingRateType: selectedShippingCalculation,
      shippingRate: shippingCharges,
      preferredShippingMethod: selectedPreferredShippingMethod?.methodName,

      products: ordersList.map((item: any) => {
        return {
          categoryId: item?.categoryId,
          subCategoryId: item?.subCategoryId,
          productId: item?.productId,
          product_id: item?.product_id,
          quantity: item?.quantity,
          confirmedQuantity: item?.confirmedQuantity ?? item?.quantity,
          price: item?.unitPrice,
          productName: item?.productName,
          totalPrice: parseFloat(
            (
              parseFloat(item?.shippingQuantity ?? item?.quantity) *
              parseFloat(item?.price)
            ).toFixed(2)
          ),
          shippingQuantity: item?.shippingQuantity ?? item?.quantity,
          ...(isInvoice && {
            invoicedQuantity: item?.shippingQuantity ?? item?.quantity,
          }),
        };
      }),
    };

    return payload;
  }

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('SHIPPED_ORDER_DETAILS')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent dividers>
        <Grid>
          {ordersList?.length > 0 && (
            <BakeasySimpleTable
              headers={shippedOrderTableHeaders}
              tableData={ordersList}
              // handleCheckChanged={handleRowCheck}
              handleShippedQuantityChanged={handleCheckQuantityChange}
            />
          )}
        </Grid>

        <Grid container mt={1}>
          <BakeasyHeaderLabel message="SHIPPING_DETAILS" />
        </Grid>

        <Grid container spacing={2} pl={2}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Dropdown.ShipTo
              disabled={true}
              value={selectedShipTo}
              onChange={(event: any) => {
                setSelectedShipTo(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Name
              disabled={true}
              value={shipToName}
              onChange={(event: any) => {
                setShipToName(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Name
              disabled={true}
              label={t('COMPANY_NAME')}
              value={shipToCompanyName}
              onChange={(event: any) => {
                setShipToCompanyName(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Address
              disabled={true}
              label={t('COMPANY_ADDRESS')}
              value={shipToAddress}
              onChange={(event: any) => {
                setShipToAddress(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.City
              disabled={true}
              value={shipToCity}
              onChange={(event: any) => {
                setShipToCity(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.State
              disabled={true}
              value={
                shipToState
                  ? t(`${shipToState?.toUpperCase().replace(/\s+/g, '_')}`)
                  : shipToState
              }
              onChange={(event: any) => {
                setShipToState(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Pincode
              disabled={true}
              value={shipToPostCode}
              onChange={(event: any) => {
                setShipToPostCode(event.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Country
              disabled={true}
              value={
                shipToCountry
                  ? t(`${shipToCountry?.toUpperCase().replace(/\s+/g, '_')}`)
                  : shipToCountry
              }
              onChange={(event: any) => {
                setShipToCountry(event.target.value);
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} pl={2} mt={0}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Dropdown.YesNo
              disabled={true}
              label={t('SHIPPING_CHARGE')}
              value={selectedShippingCharge}
              onChange={function (event: any): void {
                setSelectedShippingCharge(event?.target?.value);
                setSelectedShippingCalculation('');
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Dropdown.ShippingCalculation
              disabled={true}
              // value={selectedShippingCalculation}
              value={
                selectedShippingCalculation
                  ? t(
                      `${selectedShippingCalculation?.toUpperCase().replace(/\s+/g, '_')}`
                    )
                  : selectedShippingCalculation
              }
              onChange={(event: any) => {
                setSelectedShippingCalculation(event?.target?.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField.Number
              label={t('SHIPPING_CHARGES')}
              maxLength={4}
              disabled={true}
              value={shippingCharges}
              onChange={(event: any) => {
                setShippingCharges(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            {/* <TextField.Name
              label={t('SHIPPING_METHOD')}
              required={false}
              disabled={true}
              value={preferredShippingMethod}
              onChange={(event: any) => {
                setPreferredShippingMethod(event.target.value);
              }}
            /> */}
            <BakeasyAutoCompleteShippingMethod
              disabled={true}
              required={false}
              value={selectedPreferredShippingMethod}
              options={
                _shippingMethodsState.value?.data?.length > 0
                  ? _shippingMethodsState.value?.data
                  : null
              }
              onAddClick={(props: any) => {
                //openAddShippingMethodDialog(props);
              }}
              onChange={(newValue: any) => {
                // if (typeof newValue === 'string' && newValue?.length > 2) {
                //   dispatch(fetchShippingMethods({ page: 1, limit: 5, search: newValue }));
                // }
                // if (typeof newValue === 'string' && newValue?.length === 0) {
                //   dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                // }
                // if (typeof newValue === 'object' && newValue?.id !== 0) {
                //   setSelectedPreferredShippingMethod(newValue);
                // }
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonCancel onClick={handleClose} />
        {!showButton && (
          <BakeasyButtonUpdateShipping onClick={handleUpdateShipping} />
        )}
        {showButton && (
          <BakeasyButtonShippingMemoOnly
            onClick={async function (
              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
            ): Promise<void> {
              let payload = await createPayload(false);
              if (payload) {
                let amount: any = await calculateTotalPrice(
                  payload?.products,
                  selectedShippingCalculation, // local state ✅
                  shippingCharges
                );
                payload = { ...payload, amount };
                await dispatch(shippedOrder(payload));
                dispatch(clearOrdersState());
                myContext.setDialog({ open: false });
                navigate(-1);
              }
            }}
          />
        )}
        {showButton && (
          <BakeasyButtonShippingMemoInvoice
            onClick={async function (
              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
            ): Promise<void> {
              let payload = await createPayload(false);
              let amount: any = await calculateTotalPrice(
                payload?.products,
                selectedShippingCalculation, // local state ✅
                shippingCharges
              );
              payload = { ...payload, amount };
              let response: any = await dispatch(shippedOrder(payload));
              if (response?.payload?.status === 200) {
                let payload = await createPayload(true);
                await dispatch(createInvoice(payload));
                dispatch(clearOrdersState());
                myContext.setDialog({ open: false });
                navigate(-1);
              }
            }}
          />
        )}
      </DialogActions>
    </>
  );
};
